import { render, staticRenderFns } from "./CreateExpedient.vue?vue&type=template&id=762399ae&scoped=true&"
import script from "./CreateExpedient.vue?vue&type=script&lang=js&"
export * from "./CreateExpedient.vue?vue&type=script&lang=js&"
import style0 from "./CreateExpedient.vue?vue&type=style&index=0&id=762399ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762399ae",
  null
  
)

export default component.exports